import mainReducer from './store/mainStore';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';

let store = createStore(mainReducer, composeWithDevTools(applyMiddleware(thunk)) )

export default store;
